import { render } from "./SizeLink.vue?vue&type=template&id=d931266a"
import script from "./SizeLink.vue?vue&type=script&lang=js"
export * from "./SizeLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__